import tokens from '@lansforsakringar/core-tokens'
import { css } from 'lit'

import { scoped, declare, override, vars } from '#utils/styles'

export const locals = scoped('heading', [
	'color',
	'font_size',
	'font_weight',
	'line_height',
	'letter_spacing',
	'text_wrap'
] as const)

export default css`
	:host {
		${declare(locals, {
			letter_spacing: '0'
		})};
	}
	.heading {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
		font-family: ${vars(tokens.font_family_body)};
		color: ${vars(locals.color)};
		font-size: ${vars(locals.font_size)};
		font-weight: ${vars(locals.font_weight)};
		line-height: ${vars(locals.line_height)};
		text-wrap: ${vars(locals.text_wrap)};

		&.primary {
			${override(locals.color, locals.color, tokens.color_text_brand_primary)};
		}
		&.secondary {
			${override(locals.color, locals.color, tokens.color_text_secondary)};
		}
	}
	h1 {
		${override(locals.line_height, locals.line_height, 'calc(37 / 29)')};
		${override(locals.text_wrap, locals.text_wrap, 'balance')};
		${override(locals.font_size, locals.font_size, '1.8125rem')};
	}
	h2 {
		${override(locals.line_height, locals.line_height, 'calc(37 / 29)')};
		${override(locals.text_wrap, locals.text_wrap, 'balance')};
		${override(locals.font_size, locals.font_size, '1.8125rem')};
	}
	h3 {
		${override(locals.line_height, locals.line_height, 'calc(37 / 29)')};
		${override(locals.text_wrap, locals.text_wrap, 'pretty')};
		${override(locals.font_size, locals.font_size, '1.8125rem')};
	}
	h4 {
		${override(locals.line_height, locals.line_height, '1.5')};
		${override(locals.text_wrap, locals.text_wrap, 'pretty')};
		${override(locals.font_size, locals.font_size, '1.25rem')};
	}
`
